import React, { FC } from 'react'
import './index.scss'

interface IProps {
  rate?: number;
}

const DetailProgress: FC<IProps> = (props: IProps) => {
  const { rate } = props
  return (
    <div className='top-bar'>
      <div className='bar-progress' style={{ width: `${rate === undefined ? 100 : rate}%` }}></div>
      <div className='bar-show'></div>
    </div>
  )
}

export default DetailProgress
